import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlantsWithBOMByProductListState } from './plants-with-bom-by-product-list.reducer';
import { ProductBOM } from './plants-with-bom-by-product-list.actions';

export const selectPlantsWithBOMByProductListState =
  createFeatureSelector<PlantsWithBOMByProductListState>('plantsWithBOMByProductList');

function buildKey(products: ProductBOM[]): string {
  return JSON.stringify([...products].sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
}

export const selectPlantsWithBOMByProductListResult = (products: ProductBOM[]) =>
  createSelector(selectPlantsWithBOMByProductListState, (state) => state.cache[buildKey(products)]);

export const selectPlantsWithBOMByProductListLoading = (products: ProductBOM[]) =>
  createSelector(selectPlantsWithBOMByProductListState, (state) => state.loading[buildKey(products)]);

export const selectPlantsWithBOMByProductListError = (products: ProductBOM[]) =>
  createSelector(selectPlantsWithBOMByProductListState, (state) => state.error[buildKey(products)]);
